import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '../ui/button';

/** Bandeau d'appel à l'action (appel + RDV) en bas des pages services. */
export const CtaSection = ({ titre, texte, urgence = false }) => (
  <section className={`py-16 px-4 bg-gradient-to-br text-white ${urgence ? 'from-red-500 to-red-600' : 'from-blue-500 to-blue-600'}`} data-testid="cta-section">
    <div className="max-w-4xl mx-auto text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-6">{titre}</h2>
      <p className="text-xl mb-8">{texte}</p>
      {urgence ? (
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a href="tel:0773601521" className="text-2xl font-bold hover:underline animate-pulse">☎️ 07.73.60.15.21</a>
          <Link to="/rendez-vous">
            <Button className="bg-white text-red-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-lg transition-colors font-bold">Prendre rendez-vous d'urgence</Button>
          </Link>
        </div>
      ) : (
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a href="tel:0773601521">
          <Button className="bg-white text-blue-600 hover:bg-gray-100 px-10 py-6 text-lg rounded-xl font-bold shadow-xl">
            <Phone className="w-5 h-5 mr-2" />
            07.73.60.15.21
          </Button>
        </a>
        <Link to="/rendez-vous">
          <Button className="bg-green-500 hover:bg-green-600 text-white px-10 py-6 text-lg rounded-xl font-bold shadow-xl">
            Prendre rendez-vous
          </Button>
        </Link>
      </div>
      )}
    </div>
  </section>
);

/** Pied de page minimal des pages services. */
export const SeoFooter = ({ texte }) => (
  <footer className="bg-[#1a2332] text-white py-8 px-4">
    <div className="max-w-7xl mx-auto text-center">
      <p className="text-gray-400">{texte}</p>
    </div>
  </footer>
);
